import { Space } from 'antd'
import * as React from 'react'

import { Breadcrumb } from './Breadcrumb'
import { BreadcrumbsProps } from './breadcrumbs.models'
import { Separator } from './Separator'

import * as styles from './Breadcrumbs.module.less'

const spaceDefault = 6

export const Breadcrumbs: React.FC<BreadcrumbsProps> = (props) => {
    const {
        children,
        Link,
        islinkListLoading,
        onDropDownClick,
        onLinkClick,
        routes,
        space
    } = props

    const showLastBreadcrumb =
        props.showLastBreadcrumb !== undefined ? props.showLastBreadcrumb : true

    if (!showLastBreadcrumb) {
        routes.pop()
    }

    return (
        <div className={styles.breadcrumbsWrapper}>
            <span>
                <Space size={space || spaceDefault}>
                    {routes?.map((route, index) => {
                        const isLast = showLastBreadcrumb
                            ? routes.length - 1 === index
                            : false
                        const breadcrumb = (
                            <Breadcrumb
                                isLast={isLast}
                                label={route?.label}
                                Link={Link}
                                url={route?.url}
                                onLinkClick={onLinkClick}
                            />
                        )

                        const separator = (
                            <Separator
                                id={route?.id}
                                islinkListLoading={islinkListLoading}
                                path={route?.url}
                                Link={Link}
                                linkList={route?.children}
                                onDropDownClick={onDropDownClick}
                                onLinkClick={onLinkClick}
                            />
                        )

                        let showLastSeparator = true
                        // @ts-ignore
                        if (route?.children?.length > 0) {
                            showLastSeparator = true
                        } else {
                            showLastSeparator = false
                        }
                        // if (showLastBreadcrumb) {
                        //     showLastSeparator = isLast ? false : true
                        // } else {
                        //     showLastSeparator = true
                        // }

                        return (
                            <React.Fragment
                                key={`breadcrumb${route?.label}${route?.url}`}
                            >
                                {breadcrumb}
                                {showLastSeparator && separator}
                            </React.Fragment>
                        )
                    })}
                </Space>
            </span>
            {children && <span className={styles.children}>{children}</span>}
        </div>
    )
}
